import type { DynamicFieldKey, LayoutTypeValue } from './constants';
import { LAYOUT_TYPE_FIELDS } from './constants';

export const getDynamicFieldLabel = (field: DynamicFieldKey) => {
  switch (field) {
    case 'image':
      return 'Image 1';
    case 'image_2':
      return 'Image 2';
    case 'text':
      return 'Text 1';
    case 'text_2':
      return 'Text 2';
    case 'text_3':
      return 'Text 3';
    case 'text_4':
      return 'Text 4';
    case 'text_header_1':
      return 'Text Header 1';
    case 'text_header_2':
      return 'Text Header 2';
    case 'text_header_3':
      return 'Text Header 3';
    default:
      return 'Value';
  }
};

export const getLayoutFields = (
  layoutType: string
): readonly DynamicFieldKey[] =>
  layoutType in LAYOUT_TYPE_FIELDS
    ? (LAYOUT_TYPE_FIELDS[
        layoutType as LayoutTypeValue
      ] as readonly DynamicFieldKey[])
    : [];

export const getLayoutPreviewImage = (layoutType: string): null | string => {
  if (!layoutType || !(layoutType in LAYOUT_TYPE_FIELDS)) {
    return null;
  }
  return `/appendix-previews/${layoutType}.jpg`;
};
